import type { RouteRecordRaw } from 'vue-router';

export const LimitsRouter: RouteRecordRaw = {
  path: '/user/manage-limits',
  name: 'Manage Limits',
  component: () => import('@/views/private/LimitsManagament.vue'),
};
